import {PageContent} from './../../shared/classes/page-content.model';
import {Component, OnInit, ViewChild, ElementRef, ViewEncapsulation} from '@angular/core';
import {RightSideService} from '../../shared/right-side.service';
import {FormDataService} from '../../shared/form-data.service';
import {CourierResponse} from '../../shared/classes/courier.model';
import {FourthTab} from '../../shared/classes/fourth-tab.model';
import {storageFactory} from '../../../../app-storage';
import hbusApiClient from '../../../../analytics/hbusApiClient';

@Component({
  selector: 'app-success-header',
  templateUrl: './success-header.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./success-header.component.css']
})
export class SuccessHeaderComponent implements OnInit {
  courier: CourierResponse;
  totalPrice: number;
  productDescription: string;
  pageContent: PageContent;
  imageUrl: string;
  isIOS: boolean;
  courierInfo: FourthTab;
  @ViewChild('sucjumb') sucjumb: ElementRef;

  constructor(
    private rightDataService: RightSideService,
    private formDataService: FormDataService,
  ) {
    this.courier = this.rightDataService.getCourier();
    this.totalPrice = this.rightDataService.getPrice();
    this.productDescription = this.rightDataService.getLabel();
    this.imageUrl = this.rightDataService.getImageUrl();
    this.isIOS = (storageFactory(localStorage).getItem('isIOS') === 'true');
    this.pageContent = this.rightDataService.getPageContent();
    this.rightDataService.pageContentChange.subscribe(() => {
      this.pageContent = this.rightDataService.getPageContent();
    });
    this.courierInfo = this.formDataService.getFourthTab();
  }

  ngOnInit() {
    this.replaceCourierData();
  }

  clickOrderTracking() {
    try {
      hbusApiClient.sendEventRequest('BuybackLinkClick', {
        page_type: 'static',
        page_value: 'eskiyi-getir-yeniyi-gotur',
        text: 'Süreç takip ekranına buradan ulaşabilirsiniz.',
        targetUrl: 'https://www.hepsiburada.com/cozummerkezi/destek-taleplerim/eskiyi-yenile',
        stepNo: 5,
        stepName: 'basvuruTamamlandı'
      });
    } catch (e) {
      console.error('error send event', e.message);
    }
  }

  replaceCourierData(): void {
    if (this.pageContent) {
      this.pageContent.fourthTabSection2Text =
        this.pageContent.fourthTabSection2Text.replace(/{{courier.courier.name}}/g, this.courier.courier.name);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/header/success-header/success-header.component.ts